const footLinks = [
  { href: "#feed", label: "新鲜盘点" },
  { href: "#topics", label: "反差分类" },
  { href: "#deep", label: "深度观察" },
  { href: "#voices", label: "读者口碑" },
  { href: "#faq", label: "常见问答" },
  { href: "#about", label: "投稿联系" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="flex flex-col gap-4">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-radar-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">反差雷达</span>
            </a>
            <p className="max-w-xs text-sm leading-relaxed text-foreground-600">
              一档专注反差现象的内容观察平台，整理反差爆料聊天记录、微信截图与私聊对话的来龙去脉，理性围观、讲清逻辑。
            </p>
            <div className="flex items-center gap-2 text-foreground-600">
              <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-wechat-line" />
              </a>
              <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-weibo-line" />
              </a>
              <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-qq-line" />
              </a>
              <a href="#top" aria-label="分享" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 transition-colors hover:text-primary-600">
                <i className="ri-rss-line" />
              </a>
            </div>
          </div>

          <nav className="flex flex-col gap-4" aria-label="站内导航">
            <h3 className="font-heading text-base font-bold text-foreground-950">快速导航</h3>
            <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {footLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-arrow-right-s-line text-primary-500" />
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-base font-bold text-foreground-950">内容定位</h3>
            <p className="text-sm leading-relaxed text-foreground-600">
              我们坚持克制、客观的编辑原则：聚焦现象本身，涉及真实个人的敏感素材均做匿名与脱敏处理，不鼓励无底线扒私。
            </p>
            <a
              href="#about"
              className="inline-flex w-fit items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
            >
              投稿线索
              <i className="ri-arrow-right-line ml-1.5" />
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 反差雷达. All rights reserved.</p>
          <p className="text-xs text-foreground-500">理性围观 · 讲清逻辑 · 不追猎奇</p>
        </div>
      </div>
    </footer>
  );
}